import { render } from "./VitaLoaderSpinner.vue?vue&type=template&id=00ed42be&scoped=true"
const script = {}

import "./VitaLoaderSpinner.vue?vue&type=style&index=0&id=00ed42be&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ed42be"]])

export default __exports__